module.exports = __webpack_public_path__ + "img/greenview.4939485d.jpg";